module.exports = __webpack_public_path__ + "assets/images/rbyearend-02.jpg?v=8489c83a";